<template>
  <div>
    <h2>Pricing guide</h2>

    <p>
      Apptek is trusted by top media & entertainment companies, language service
      providers, and develoment teams around the world. Prototype with our Trial
      plan for peace of mind, then let us know when you're ready for
      an Enterprise account.
    </p>

    <b-row>
      <b-col cols="12" lg="6" class="my-3">
        <b-card
          border-variant=""
          header-html=""
          header-bg-variant="primary"
          header=""
          header-text-variant="primary"
          align="center"
          class="trial shadow"
        >
          <b-card-text class="px-1 py-2">
            <h2>Trial</h2>
            <p>Start here and build</p>
            <p>Free for 30 days</p>
            <b-button href="#"
                      variant="success"
                      size="md"
                      class="w-50 my-2"
                      disabled>Current plan</b-button>
            <div class="text-left mt-3">
              <ul class="text-secondary">
                <li>Full access to all standard features. </li>
                <li>Translate up to 50,000 characters.</li>
                <li>Transcribe up to 300 minutes.</li>
              </ul>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="12" lg="6" class="my-3">
        <b-card
          border-variant=""
          header-html=""
          header-bg-variant="primary"
          header=""
          header-text-variant="primary"
          align="center"
          class="enterprise shadow"
        >
          <b-card-text class="px-1 py-2">
            <h2>Custom</h2>
            <p>Enterprise power and support</p>
            <p>Custom pricing</p>
            <b-button href="#"
                      variant="primary"
                      size="md"
                      @click.prevent="openModal()"
                      class="w-50 my-2">Contact us</b-button>

            <div class="text-left mt-3">
              <ul class="text-secondary">
                <li>Dedicated success team. </li>
                <li>24/7 support and SLA.</li>
                <li>On-site deployment options.</li>
              </ul>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <br />
    <br />
    <h5 class="mb-3">Standard features provided in all plans</h5>
    <b-row>
      <b-col cols="12" md="6" class="pl-5 pb-3" v-for="(feature, index) in features" :key="index">
        <p class="benefit">
          <b-icon icon="check-circle" shift-h="-6" class="mr-0 checkmark"></b-icon>
          {{ feature.title }}<br />
          <span class="text-secondary">{{ feature.description }}</span>
        </p>
      </b-col>
    </b-row>

    <b-modal id="modal-contact-us" size="lg" hide-footer>
      <div class="px-5 py-4">
        <h4 class="mb-4">How can we help you?</h4>
        <p>Get access to our full range of services and 24/7 support for your team. </p>

        <p>Let us know what you'd like to achieve, and our team will design a custom plan.
        </p>
        <form ref="form">
          <b-row>
            <b-col cols="12">
              <b-form-textarea
                name="message"
                v-model="message"
                placeholder="How we can help"
                rows="5"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <p class="text-secondary my-4 sm">You have already registered your
            email address ({{ email }}) <span v-if='mobile.length > 5'>and
            phone number ({{ mobile }})</span>. If you would prefer to be contacted
            via another means, please indicate it above. Thank you.
          </p>
          <b-row v-if="sending">
            <b-col cols="12 text-center">
                <div class="text-info">
                  Sending ...
                  <b-spinner small class="ml-auto" variant="info"></b-spinner>
                </div>
            </b-col>
          </b-row>
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
           Your message has been sent.
          </b-alert>
          <b-row>
            <b-col cols="12" class="text-right">
              <b-button
                class="mt-3"
                variant="primary"
                @click="sendMessage()"
                :disabled="!messageSendable"
                >Send message</b-button
              >
            </b-col>
          </b-row>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import apiClient from '@/services/api_client_crm.js'

export default {
  data () {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      message: '',
      sending: false,
      features: [
        {
          title: 'Transcribe (speech to text)',
          description: 'Extract text from audio or video media.'
        },
        {
          title: 'Translate',
          description: 'Translate text between languages.'
        },
        {
          title: 'Punctuation',
          description: 'All transcripts will be correctly punctuated.'
        },
        {
          title: 'Cloud APIs',
          description: 'No infrastructure required. Use our APIs immediately.'
        },
        {
          title: 'Realtime & offline APIs',
          description: 'Offline APIs for bulk conversion.'
        },
        {
          title: 'Diarization',
          description: 'All transcripts will indicate the speaker.'
        },
        {
          title: 'Redaction',
          description: 'Remove sensitive information to ensure compliance.'
        },
        {
          title: 'Intelligent line segmentation',
          description: 'Line breaks and wrapping optimized for readability.'
        },
        {
          title: 'Sentiment',
          description: 'All transcripts will indicate where sentiment is positive or negative.'
        }
      ]
    }
  },
  methods: {
    openModal () {
      this.$bvModal.show('modal-contact-us')
    },
    // For the alert
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    sendMessage () {
      this.sending = true
      apiClient.post('/api/contact-us', {
        message: this.message
      }).then((response) => {
        this.showAlert()
        this.sending = false
      }).catch((error) => {
        this.sending = false
        if (error.response) {
          console.log(error.response.data) // => the response payload
        }
      })
    }
  },
  computed: {
    messageSendable () {
      return (typeof this.message === 'string' || this.message instanceof String) ? this.message.length > 4 : false
    },
    ...mapGetters([
      'email',
      'mobile'
    ])
  }
}
</script>

<style scoped>
.trial {
  border-top: 3px lightseagreen solid;
}
.enterprise {
  border-top: 3px blue solid;
}
p.benefit {
 text-indent: -1.2em
}
.checkmark {
  color: lightseagreen
}
</style>
